"use strict";

var _Object$defineProperty = require("@babel/runtime-corejs3/core-js-stable/object/define-property");
var _interopRequireDefault = require("@babel/runtime-corejs3/helpers/interopRequireDefault");
_Object$defineProperty(exports, "__esModule", {
  value: true
});
exports.BannerWrapper = void 0;
var _base = _interopRequireDefault(require("@emotion/styled/base"));
var _uiTheme = require("@kyruus/ui-theme");
const BannerWrapper = exports.BannerWrapper = /*#__PURE__*/(0, _base.default)("div", process.env.NODE_ENV === "production" ? {
  target: "e10foqnl0"
} : {
  target: "e10foqnl0",
  label: "BannerWrapper"
})(">div{margin-top:", (0, _uiTheme.fromTheme)('spacing_small'), ";}" + (process.env.NODE_ENV === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIi4uLy4uLy4uL3NyYy9jb21wb25lbnRzL0Jvb2tCdXR0b24vc3R5bGVzLmpzIl0sIm5hbWVzIjpbXSwibWFwcGluZ3MiOiJBQUd1QyIsImZpbGUiOiIuLi8uLi8uLi9zcmMvY29tcG9uZW50cy9Cb29rQnV0dG9uL3N0eWxlcy5qcyIsInNvdXJjZXNDb250ZW50IjpbImltcG9ydCB7IGZyb21UaGVtZSB9IGZyb20gJ0BreXJ1dXMvdWktdGhlbWUnO1xuaW1wb3J0IHN0eWxlZCBmcm9tICdAZW1vdGlvbi9zdHlsZWQnO1xuXG5leHBvcnQgY29uc3QgQmFubmVyV3JhcHBlciA9IHN0eWxlZC5kaXZgXG4gID4gZGl2IHtcbiAgICBtYXJnaW4tdG9wOiAke2Zyb21UaGVtZSgnc3BhY2luZ19zbWFsbCcpfTtcbiAgfVxuYDsiXX0= */"));